import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=650c1fee&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('650c1fee')) {
      api.createRecord('650c1fee', component.options)
    } else {
      api.reload('650c1fee', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=650c1fee&", function () {
      api.rerender('650c1fee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FabrPFTM6gCb/JS/childrenage.vue"
export default component.exports